export enum FulfillmentStatusType {
  Pending = "Pending",
  Started = "Started",
  OnHold = "OnHold",
  Completed = "Completed",
  Canceled = "Canceled",
  Failed = "Failed",
  PendingCompletionApproval = "PendingCompletionApproval"
}
